import { useEffect } from 'react';
import { RouterProvider } from 'react-router-dom';
import { router } from './routes';
import { useSession } from './state/session';
import { Toaster } from './ui/Toast';

/**
 * Providers + session bootstrap. Feature owners: do not add routes here, add them
 * in routes.tsx; do not add global stores here, they are plain zustand modules.
 */
export function App() {
  const refresh = useSession((s) => s.refresh);
  useEffect(() => {
    void refresh();
  }, [refresh]);

  return (
    <>
      <RouterProvider router={router} />
      <Toaster />
    </>
  );
}
